module.exports = __webpack_public_path__ + "img/senegal.fb9a9874.svg";